import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-remove-past-order',
  templateUrl: 'remove-past-order.component.html',
  styleUrls: ['../my-cart/my-cart.component.scss'],
})
export class RemovePastOrderComponent implements OnInit {

  ngOnInit() {
  }

  constructor(private activeModal: NgbActiveModal) {
  }

  closeModal(status) {
    this.activeModal.close(status);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/remove-cart-past-order/remove-past-order.component.ts